import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Container, Row, Col, Card, CardBody } from 'shards-react';

import { FiAlertCircle } from 'react-icons/fi';

import PageTitle from '../../components/common/PageTitle';
import LoadingContainer from '../../components/layout/LodingContainer';
import Pagination from '../../components/common/Pagination';

import { dateAndSeconds } from '../../utils/dateFormatter';

import { getStampExpirationLogs } from '../../store/modules/logs/actions';

import * as SelectedData from '../../store/modules/selectedData/actions';

import { scrollToTop } from '../../utils/scrolls';

export default function StampExpirationLogs() {
  const dispatch = useDispatch();

  const { stampExpirationLogs, loading } = useSelector((state) => state.logs);

  const selectedInstitution = useSelector(
    (state) => state.selectedData.selectedInstitution
  );

  const [filteredInstitution] = useState(selectedInstitution);

  const [page, setPage] = useState(1);
  const [total] = useState(0);
  const [itemsSize, setItemsSize] = useState(20);

  const handleGetStampExpirationLogs = useCallback(() => {
    dispatch(getStampExpirationLogs(() => {}));
  }, [dispatch]);

  useEffect(() => {
    if (stampExpirationLogs) handleGetStampExpirationLogs();
  }, [page, itemsSize]);

  useEffect(() => {
    dispatch(SelectedData.selectInstitution(filteredInstitution));
  }, [filteredInstitution]);

  return (
    <Container fluid className="main-content-container px-4">
      {/* Page Header */}
      <Row noGutters className="page-header py-4">
        <PageTitle
          sm="4"
          title="Expiração de Carimbo"
          subtitle="Logs"
          className="text-sm-left"
        />
      </Row>
      {/* Filters */}
      {loading && (
        <Row>
          <Col>
            <Card small className="mb-4">
              <CardBody className="p-0 pb-3 pl-3 pr-3 overflow-auto">
                {loading && <LoadingContainer loading={loading} />}
              </CardBody>
            </Card>
          </Col>
        </Row>
      )}
      {!loading &&
        stampExpirationLogs?.data?.content?.rows &&
        stampExpirationLogs?.data?.content?.rows?.length > 0 && (
          <Row>
            <Col>
              <Card small className="mb-4">
                <CardBody className="p-0 pb-3 pl-3 pr-3 overflow-auto">
                  <>
                    <table className="table mb-0">
                      <thead className="bg-light">
                        <tr>
                          <th scope="col" className="border-0">
                            Provedor de carimbo
                          </th>
                          <th scope="col" className="border-0">
                            Serial
                          </th>
                          <th scope="col" className="border-0">
                            Data de criação
                          </th>
                          <th scope="col" className="border-0">
                            Data de expiração
                          </th>
                          <th scope="col" className="border-0">
                            Último uso
                          </th>
                          <th scope="col" className="border-0">
                            Total de utilizações
                          </th>
                          <th scope="col" className="border-0">
                            Último documento utilizado
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {stampExpirationLogs?.data?.content?.rows &&
                          stampExpirationLogs?.data?.content?.rows?.map(
                            (s, index) => (
                              <tr key={index}>
                                <td>Bry</td>
                                <td>{s.serial}</td>
                                <td>{dateAndSeconds(s.createdAt)}</td>
                                <td>{dateAndSeconds(s.expiration)}</td>
                                <td>{dateAndSeconds(s.lastSeen)}</td>
                                <td>{s.usageCount}</td>
                                <td>{s.lastSeenOnOurNumber}</td>
                              </tr>
                            )
                          )}
                      </tbody>
                    </table>
                    <Pagination
                      total={total}
                      page={page}
                      items={itemsSize}
                      onChangePage={(e) => {
                        scrollToTop(e);
                        setPage(e);
                      }}
                      onChangeItems={(e) => {
                        scrollToTop();
                        setItemsSize(e);
                      }}
                    />
                  </>
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}
      {!loading &&
        stampExpirationLogs?.data?.content?.rows &&
        stampExpirationLogs?.data?.content?.rows?.length === 0 && (
          <Row>
            <Col>
              <Card small className="mb-4">
                <CardBody className="p-0 pb-3 pl-3 pr-3 overflow-auto">
                  <div className="col-sm-12 d-flex justify-content-center">
                    <h5 className="mt-3">
                      <FiAlertCircle className="mr-2" />
                      Não existem logs encontrados para os filtros escolhidos.
                    </h5>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}
    </Container>
  );
}
